/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { MultiDocumentAgentControllerStreamResponseQueryResponse, MultiDocumentAgentControllerStreamResponsePathParams, MultiDocumentAgentControllerStreamResponse401, MultiDocumentAgentControllerStreamResponse403, MultiDocumentAgentControllerStreamResponse404, MultiDocumentAgentControllerStreamResponse503 } from "../../models/multiDocumentAgentController/MultiDocumentAgentControllerStreamResponse";

function getMultiDocumentAgentControllerStreamResponseUrl(requestId: MultiDocumentAgentControllerStreamResponsePathParams["requestId"]) {
  const res = { method: 'GET', url: `/api/v1/multi-document-agent/stream/${requestId}` as const }  
  return res
}

/**
 * @description Streams real-time agent events from Redis Streams. Supports multi-instance horizontal scaling.
 * @summary Stream agent responses via Server-Sent Events
 * {@link /api/v1/multi-document-agent/stream/:requestId}
 */
export async function multiDocumentAgentControllerStreamResponse(requestId: MultiDocumentAgentControllerStreamResponsePathParams["requestId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<MultiDocumentAgentControllerStreamResponseQueryResponse, ResponseErrorConfig<MultiDocumentAgentControllerStreamResponse401 | MultiDocumentAgentControllerStreamResponse403 | MultiDocumentAgentControllerStreamResponse404 | MultiDocumentAgentControllerStreamResponse503>, unknown>({ method : "GET", url : getMultiDocumentAgentControllerStreamResponseUrl(requestId).url.toString(), ... requestConfig })  
  return res.data
}